import React from 'react';
import { StyleSheet, View } from 'react-native';

import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

/* ─── Shared styles for project preview / welcome screens ────────────────── */

export const sharedStyleDefs = {
  topBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.s,
    backgroundColor: theme.colors.white,
    position: 'sticky' as any,
    top: 0,
    zIndex: 10,
  },
  topBarAvatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: theme.colors.grey02,
    alignItems: 'center',
    justifyContent: 'center',
  },
  scroll: {
    flex: 1,
    backgroundColor: theme.colors.grey01,
  },
  headerTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing.xs,
  },
  projectIconBox: {
    width: 36,
    height: 36,
    borderRadius: theme.borderRadii.xs,
    backgroundColor: 'rgba(255,255,255,0.2)',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing.s,
  },
  projectName: {
    flex: 1,
    color: theme.colors.white,
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 26,
  },
  addressText: {
    color: theme.colors.white,
    fontSize: 13,
    lineHeight: 18,
    opacity: 0.85,
    marginBottom: theme.spacing.s,
  },
  metaRow: {
    flexDirection: 'row',
    marginTop: theme.spacing.xs,
  },
  metaHalf: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  metaHalfFull: {
    flex: 0,
  },
  teamIconBox: {
    width: 26,
    height: 26,
    borderRadius: theme.borderRadii.xxs,
    backgroundColor: theme.colors.black,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing.xs,
  },
  mobTeamLogoImg: {
    width: 24,
    height: 24,
    borderRadius: theme.borderRadii.xxs,
  },
  ownerAvatar: {
    width: 26,
    height: 26,
    borderRadius: 13,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    marginRight: theme.spacing.xs,
  },
  ownerAvatarImage: {
    width: 26,
    height: 26,
  },
  ownerInitials: {
    color: theme.colors.white,
    fontSize: 10,
    fontWeight: '700',
  },
  metaText: {
    color: theme.colors.white,
    fontSize: 13,
    fontWeight: '500',
    flex: 1,
  },
  card: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadii.xs,
    padding: theme.spacing.m,
    marginBottom: theme.spacing.s,
  },
  descriptionText: {
    fontSize: 14,
    lineHeight: 22,
    color: theme.colors.textSecondary,
  },
  membersSection: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadii.xs,
    padding: theme.spacing.m,
    marginBottom: theme.spacing.s,
  },
  membersRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: theme.spacing.m,
  },
  memberItem: {
    alignItems: 'center',
    marginRight: theme.spacing.m,
    marginBottom: theme.spacing.xs,
    width: 56,
  },
  memberAvatar: {
    width: 56,
    height: 56,
    borderRadius: 28,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  memberAvatarImage: {
    width: 56,
    height: 56,
  },
  memberInitials: {
    color: theme.colors.white,
    fontSize: 22,
    fontWeight: '400',
  },
  memberName: {
    fontSize: 12,
    color: theme.colors.textSecondary,
    textAlign: 'center',
    marginTop: 6,
  },
  featureCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadii.xs,
    padding: theme.spacing.m,
    marginBottom: theme.spacing.s,
  },
  featureRowContent: {
    flex: 1,
    marginLeft: theme.spacing.m,
  },
  featureTitleDisabled: {
    fontSize: 16,
    fontWeight: '600',
    color: theme.colors.grey04,
  },
  featureSubtitle: {
    fontSize: 12,
    color: theme.colors.grey03,
    marginTop: 2,
  },
  featureGrid: {
    flexDirection: 'row',
    marginBottom: theme.spacing.s,
  },
  featureGridCell: {
    flex: 1,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadii.xs,
    padding: theme.spacing.m,
  },
  greyIconBox: {
    borderRadius: theme.borderRadii.xs,
    backgroundColor: theme.colors.grey02,
    alignItems: 'center',
    justifyContent: 'center',
  },
} as const;

export const projectPreviewSharedStyles = StyleSheet.create(sharedStyleDefs);

/* ─── Shared GreyIconBox component ───────────────────────────────────────── */

export const GreyIconBox: React.FC<{
  iconName: React.ComponentProps<typeof Icon>['name'];
  size?: number;
}> = ({ iconName, size = 40 }) => (
  <View
    style={[
      projectPreviewSharedStyles.greyIconBox,
      { width: size, height: size },
    ]}>
    <Icon
      name={iconName}
      width={size === 36 ? 18 : 20}
      height={size === 36 ? 18 : 20}
      color='grey04'
    />
  </View>
);
